import React from 'react'

export const Strong: React.FC = ({ children }) => (
  <span className="stk-text-strong">{children}</span>
)
